/**
 * Given an array of objects that contain an isVisible property, returns the first member with
 * isVisible = true, or undefined.
 */
export const getVisibleObjects = arr => arr.filter(o => o.isVisible);